export const PRODUCT_GRID_TYPE = 'product grid'
export const ENDCAP_GRID_TYPE = 'endcap'
export const EMPTY_GRID_TYPE = 'empty'
export const AD_SHOWCASE_GRID_TYPE = 'ad_showcase'
export const SHELF_GRID_TYPE = 'shelf'
export const COMPLEMENTARY_SHELF_GRID_TYPE = 'complementary_shelf'
